import { z } from "zod";

export const testimonialFormSchema = z.object({
  firstName: z
    .string()
    .trim()
    .nonempty("First name is required.")
    .min(2, "First name must be at least 2 characters")
    .max(50, "First name must be less than 50 characters")
    .refine(val => !/\s/.test(val), {
      message: "Spaces are not allowed in first name"
    })
    .refine(val => !/\d/.test(val), {
      message: "Numbers are not allowed in first name"
    })
    .refine(val => /^[A-Za-zÀ-ÿ''-]+$/.test(val), {
      message: "Special characters are not allowed in first name"
    }),

  message: z
    .string()
    .trim()
    .min(10, "Message must be at least 10 characters")
    .max(700, "Message must be less than 700 characters")
    .trim()
    .refine((val) => val.length > 0, {
      message: "Message cannot be only spaces",
    }),
});

export type TestimonialFormSchema = z.infer<typeof testimonialFormSchema>;
